import React from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { ReactComponent as LeftArrowBackIcon } from "../../../img/arrow_left.svg";
import { WrapStatus } from "../../../types/wrapQuote";

export const WrapBackButton: React.FC = props => {
  const theme = GlobalStore.useState(s => s.theme);
  const handleOnClick = () => {
    GlobalStore.update(s => {
      s.wrapStatus = WrapStatus.ENTRY;
    });
  };

  return (
    <button className="back-btn text-green p-0" onClick={() => handleOnClick()}>
      <LeftArrowBackIcon style={{ color: theme.button.primary.surface.active }} />
      Back
    </button>
  );
};
